const autoNgTemplateLoaderTemplate1 = require('./kube-services-item.html');

import angular from 'angular';
import controller from './kube-services-item.controller';

angular.module('shbdeployer.kubernetes').component('kubeServicesItemView', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller,
  bindings: {
    serviceType: '<',
    servicePorts: '=',
    serviceRoutes: '=',
    ingressType: '<',
    originalIngresses: '<',
    isEdit: '<',
    serviceName: '<',
    multiItemDisable: '<',
    serviceIndex: '<',
    loadbalancerEnabled: '<',
  },
});
